export const ApiQueryKey = {
	companies: 'companies',
	admins: 'admins',
	clients: 'clients',
	merchants: 'merchants',
	loginHistory: 'login-histories',

	contents: 'contents',
	notifications: 'notifications',
	files: 'files',
	fileCategories: 'file-categories',
	products: 'products',

	productTypeCategories: 'product-type-categories',
	productTypes: 'product-types',

	productModels: 'product-models',
	complaints: 'complaints',
	orders: 'orders',
	offers: 'offers',
	roles: 'roles',
	attributes: 'attributes',
	attributeValues: 'attribute-values',
	components: 'components',
	contacts: 'contacts',

	accessoryCategories: 'accessory-categories',
} as const;

export type ApiQueryKey = (typeof ApiQueryKey)[keyof typeof ApiQueryKey];
